import ModelFactory from '../model-factory';
import {
  BaseModel,
} from '../models';

/**
 * format example at end of file
 */
export default class RegisterSession extends BaseModel {
  constructor(opts) {
    super(opts);
    this.sessions = [];
    if (opts.session
      && (opts.session != null || opts.session.length > 0)) {
      opts.session.forEach((session) => {
        const { soporte, fechas, sistemaOperativo } = session;
        this.sessions.push({
          soporte: soporte
          || null,
          fecha: fechas.fecha
           || null,
          sistemaOperativo: sistemaOperativo || null,
        });
      });
    }
  }
}

export const modelFactory = new ModelFactory('sesiones', (data) => new RegisterSession(data));
